import React from 'react';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../../app/commonReducer';
import { withComponentId } from '../../../../common/ComponentIdContext';
import { withComponentName } from '../../../../common/ComponentNameContext';
import { TYPE_DISABLE } from '../../../../common/sync-component/Const';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../../../helpers/EventEmitter';
import CellHover from '../../../../market/watchlist/summary/CellHover';
import { REDUCER_NAME } from '../reducer';
import { connect } from 'react-redux';
import { keyBy } from 'lodash';
import { compose } from 'redux';

import Table from '../../../../common/table/Table';
import Const from '../Const';
import HeaderTable from '../../../../common/mixTable/headerTable/HeaderTable';
import {
  formatPercent,
  formatTextFloat,
  convertStringToFloat,
} from '../../../../helpers/Text';
import './Overview.scss';
import {
  getDataFollowKeyByDot,
  syncComponentSelector,
} from '../../../../helpers/Common';
import TradingViewUrl from '../../../../common/TradingViewUrl';

class OverviewTable extends React.Component {
  getDataFromRedux = state => state[REDUCER_NAME].listOverviewByTicker;

  getSchema = () => {
    const getClassName = item => {
      return item < 0 ? 'isRed' : '';
    };

    return Object.keys(Const.overvew.listOverviewTable).map(item => {
      const key = Const.overvew.listOverviewTable[item];
      const title = `strategy.listOverviewTable.${item}`;
      const result = {
        key,
        title,
      };
      if (key === Const.overvew.listOverviewTable.ticker) {
        return {
          ...result,
          isString: true,
          valueFromItem: item => item.ticker,
          render: (text, item) => (
            <CellHover organCode={item.organCode} isShowDeleteIcon={false}>
              <div className="text-left">
                <TradingViewUrl
                  code={getDataFollowKeyByDot(item, Const.organCode)}
                />
                &nbsp;{item.ticker}
              </div>
            </CellHover>
          ),
        };
      }
      if (key === Const.overvew.listOverviewTable.roe) {
        return {
          ...result,
          thStyle: { textAlign: 'right' },
          valueFromItem: item => item.roe,
          render: (text, item) => {
            return <div>{formatPercent(item.roe) + '%'}</div>;
          },
        };
      }
      if (key === Const.overvew.listOverviewTable.roa) {
        return {
          ...result,
          thStyle: { textAlign: 'right' },
          valueFromItem: item => item.roa,
          render: (text, item) => {
            return <div>{formatPercent(item.roa) + '%'}</div>;
          },
        };
      }
      if (key === Const.overvew.listOverviewTable.pe) {
        return {
          ...result,
          thStyle: { textAlign: 'right' },
          valueFromItem: item => item.pe,
          render: (text, item) => {
            return (
              <div className={getClassName(item.pe)}>
                {formatTextFloat(convertStringToFloat(item.pe))}
              </div>
            );
          },
        };
      }
      if (key === Const.overvew.listOverviewTable.pb) {
        return {
          ...result,
          thStyle: { textAlign: 'right' },
          valueFromItem: item => +item.pb,
          render: (text, item) => {
            return <div>{formatTextFloat(convertStringToFloat(item.pb))}</div>;
          },
        };
      }

      return result;
    });
  };

  onRowClick = organCode => {
    const { listOrganizationByOrganCode, syncType } = this.props;
    if (syncType === TYPE_DISABLE || !listOrganizationByOrganCode[organCode]) {
      return;
    }
    EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
      syncType: syncType,
      search: listOrganizationByOrganCode[organCode],
    });
  };

  render() {
    const {
      isFetching,
      titleHeaderTable,
      colorLeft,
      colorRight,
      data = [],
    } = this.props;

    const listIds = data.map(item => getDataFollowKeyByDot(item, 'ticker'));

    const listFullData = keyBy(data, 'ticker');

    return (
      <div>
        <HeaderTable
          title={titleHeaderTable}
          colorLeft={colorLeft || null}
          colorRight={colorRight || null}
        />
        <div className="tab-pane active">
          <Table
            clickRow={this.onRowClick}
            resizable={true}
            columnDraggable={false}
            rowDraggable={false}
            getDataFromRedux={() => listFullData}
            isLoading={isFetching}
            ids={listIds}
            schema={this.getSchema()}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, { componentName, componentId }) => {
  return {
    ids: state[REDUCER_NAME].listOverview,
    listOverviewByTicker: state[REDUCER_NAME].listOverviewByTicker,
    syncType: syncComponentSelector(state, componentName, componentId),
    listOrganizationByOrganCode:
      state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
  };
};

const enhance = compose(
  withComponentName,
  withComponentId,
  connect(mapStateToProps),
);
export default enhance(OverviewTable);
